import { render, staticRenderFns } from "./Assessment-details.vue?vue&type=template&id=01f36774"
import script from "./Assessment-details.vue?vue&type=script&lang=js"
export * from "./Assessment-details.vue?vue&type=script&lang=js"
import style0 from "./Assessment-details.vue?vue&type=style&index=0&id=01f36774&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports